<template>
  <div class="call-me-page hide-popup-by-click" @mousedown="hidePopup" style="position: fixed; z-index: 9999999; height: 100vh">
    <div class="call-me-page__form-wrapper">
      <div class="call-me-page-form" v-show="!isSuccess && !showSms">
        <iframe
          src="https://vk.com/video_ext.php?oid=-211765206&id=456239516&hd=2&autoplay=1"
          width="325"
          height="646"
          style="background-color: #000"
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <div class="call-me-page-form__close_button hide-popup-by-click"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationVideo',
  data() {
    return {
      isSuccess: false,
    };
  },
  methods: {
    hidePopup(event) {
      const CLASS_TO_RUN = 'hide-popup-by-click';
      if (!event.target.classList.contains(CLASS_TO_RUN)) return;

      this.$emit('hidePopup', null);
      this.isSuccess = false;
    },
  },
};
</script>

<style scoped>
.lahta-oncall .call-me-page__form-wrapper iframe {
  width: 100%;
  height: 100%;
  display: block;
  max-width: 100%;
}
.call-me-page-form {
  height: 100%;
}
@media (min-width: 767px) {
  .lahta-oncall .call-me-page__form-wrapper {
    width: 500px;
    max-width: 100%;
  }

  .call-me-page-form {
    height: 600px;
  }
}
</style>
